<template>
  <div class="home">
    <PageTitle title="About Hacker News" />
    <h2>This is a read-only web client for Hacker News!</h2>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
export default {
  name: 'About',
  components: { PageTitle }
}
</script>
<style lang="scss" scoped>
@import "src/styles/theme";
.home {
  background-color: whitesmoke;
  height: calc(100vh - #{$navBarHeight});
}
</style>
